import { Header } from './Header';
import { Footer } from './Footer';

function Layout(props: any) {
    return (
        <div>
            <Header />
            <div className="header-spacer"></div>
            <main>
                <div className="homepage-hero-banner">{props.children}</div>
            </main>
            <div className="header-spacer"></div>
            <Footer />
        </div>
    );
}
export default Layout;


